import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import SelectAsyncCustom from './FormControls/SelectAsyncCustom';
import * as Constants from '../Constants';
import { Chart } from "react-google-charts";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import "react-datepicker/dist/react-datepicker.css";
import { Checkbox } from '@material-ui/core';

const ConsultationTypes = {
    issueReferred: 'issueReferred',
    consultationResearcher: 'consultationResearcher',
    studyDevelopmentAssistance: 'studyDevelopmentAssistance',
    researchCollaborators: 'researchCollaborators',
    researchSiteCollaboration: 'researchSiteCollaboration',
    clinicalTrialAssistance: 'clinicalTrialAssistance',
    clinicalTrialsGovAssistance: 'clinicalTrialsGovAssistance',
    regulatoryGuidance: 'regulatoryGuidance',
    biostatisticsAssistance: 'biostatisticsAssistance'
};

export class Statistics extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            institutions: null,
            institutionParams: null,
            subInstitutions: null,
            positions: null,
            interests: null,
            results: null,
            activityType: null,
            consultationType: null,
            [ConsultationTypes.issueReferred]: [],
            [ConsultationTypes.consultationResearcher]: '',
            [ConsultationTypes.studyDevelopmentAssistance]: [],
            [ConsultationTypes.researchCollaborators]: '',
            [ConsultationTypes.researchSiteCollaboration]: [],
            [ConsultationTypes.clinicalTrialAssistance]: '',
            [ConsultationTypes.clinicalTrialsGovAssistance]: [],
            [ConsultationTypes.regulatoryGuidance]: [],
            [ConsultationTypes.biostatisticsAssistance]: [],
            labelEntities: null,
            includeAllResearchersUnderContact: true,
            useUniqueResearchers: false
        };

        this.getContacts = this.getContacts.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.getInstitutionsQueryString = this.getInstitutionsQueryString.bind(this);
        this.handleInstitutionChanged = this.handleInstitutionChanged.bind(this);
    }

    componentDidMount() {
        this.getContacts();
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.getContacts();
    }

    getInstitutionsQueryString(institutions) {
        if (!institutions || !institutions.length) {
            return '';
        }

        var paramVars = {};
        const params = new URLSearchParams();

        paramVars.parentIds = [];

        institutions.map(m => params.append('parentIds', m.value));

        return params;

        //this.setState({ institutionParams: params });
    }

    handleInstitutionChanged(e) {
        this.setState({ institutions: e, institutionParams: this.getInstitutionsQueryString(e) });
    }

    renderFilterForm() {
        return (
            <div className="card my-3">
                <div className="card-header">Filters</div>
                <div className="card-body">
                    <form onSubmit={this.handleFormSubmit}>
                        <div className="row">
                            <div className="col">
                                <SelectAsyncCustom name="activityType" title="Type of Activity" value={this.state.activityType} url={'api/contacts/get-label-entity-select-options?category=' + Constants.ActivityType} onChange={option => { this.setState({ activityType: option }); }} />
                            </div>
                            <div className="col">
                                <SelectAsyncCustom name="position" title="Researcher Position" value={this.state.positions} url={'api/contacts/get-label-entity-select-options?category=' + Constants.Position} onChange={option => { this.setState({ positions: option }); }} isMulti />
                            </div>
                            <div className="col">
                                <SelectAsyncCustom name="interests" title="Areas of Interest" value={this.state.interests} url={'api/contacts/get-label-entity-select-options?category=' + Constants.AreaOfInterest} onChange={option => { this.setState({ interests: option }); }} isMulti />
                            </div>
                        </div>
                        {this.state.activityType && this.state.activityType.id == '4' &&
                            <div className="row">
                                <div className="col-6">
                                    <SelectAsyncCustom name="consultationType" title="Type of Consultation" value={this.state.consultationType} url="api/contacts/get-label-entity-select-options?category=ConsultationType" onChange={option => this.setState({ consultationType: option })} />
                                </div>

                                {this.state.consultationType && this.state.consultationType.id == "8" &&
                                    <div className="col-6">
                                        <SelectAsyncCustom name={ConsultationTypes.issueReferred} title={this.state.consultationType.label} value={this.state.labelEntities} url={'api/contacts/get-label-entity-select-options?category=' + Constants.IssueReferred} onChange={option => this.setState({ labelEntities: option })} isMulti />
                                    </div>
                                }

                                {this.state.consultationType && this.state.consultationType.id == "10" &&
                                    <div className="col-6">
                                        <SelectAsyncCustom name={ConsultationTypes.studyDevelopmentAssistance} title={this.state.consultationType.label} value={this.state.labelEntities} url={'api/contacts/get-label-entity-select-options?category=' + Constants.StudyDevelopmentType} onChange={option => this.setState({ labelEntities: option })} isMulti />
                                    </div>
                                }

                                {this.state.consultationType && this.state.consultationType.id == "12" &&
                                    <div className="col-6">
                                        <SelectAsyncCustom name={ConsultationTypes.researchSiteCollaboration} title={this.state.consultationType.label} value={this.state.labelEntities} url={'api/contacts/get-label-entity-select-options?category=' + Constants.ResearchSiteCollaboration} onChange={option => this.setState({ labelEntities: option })} isMulti />
                                    </div>
                                }

                                {this.state.consultationType && this.state.consultationType.id == "14" &&
                                    <div className="col-6">
                                        <SelectAsyncCustom name="labelEntities" title={this.state.consultationType.label} value={this.state.labelEntities} url={'api/contacts/get-label-entity-select-options?category=' + Constants.ClinicalTrialsGovAssistance} onChange={option => this.setState({ labelEntities: option })} isMulti />
                                    </div>
                                }

                                {this.state.consultationType && this.state.consultationType.id == "15" &&
                                    <div className="col-6">
                                        <SelectAsyncCustom name={ConsultationTypes.regulatoryGuidance} title={this.state.consultationType.label} value={this.state.labelEntities} url={'api/contacts/get-label-entity-select-options?category=' + Constants.RegulatoryGuidance} onChange={option => this.setState({ labelEntities: option })} isMulti />
                                    </div>
                                }

                                {this.state.consultationType && this.state.consultationType.id == "206" &&
                                    <div className="col-6">
                                        <SelectAsyncCustom name={ConsultationTypes.biostatisticsAssistance} title={this.state.consultationType.label} value={this.state.labelEntities} url={'api/contacts/get-label-entity-select-options?category=' + Constants.BiostatisticsAssistance} onChange={option => this.setState({ labelEntities: option })} isMulti />
                                    </div>
                                }
                            </div>
                        }
                        <div className="row">
                            <div className="col">
                                <SelectAsyncCustom name="institution" title="College" value={this.state.institutions} url={'api/contacts/get-label-entity-select-options?category=' + Constants.Institution} onChange={this.handleInstitutionChanged} isMulti />
                            </div>
                            <div className="col">
                                {this.state.institutionParams &&
                                    <SelectAsyncCustom name="subInstitution" title="Department" value={this.state.subInstitutions} url={'api/contacts/get-label-entity-select-options-by-parents?' + this.state.institutionParams} onChange={option => { this.setState({ subInstitutions: option }); }} isMulti key={this.state.institutionParams} />
                                }
                            </div>
                        </div>
                        {/*<div className="row">*/}
                        {/*    <div className="col">*/}
                        {/*        <SelectAsyncCustom name="labelEntities" title="All Fields" value={this.state.labelEntities} url={'api/contacts/get-label-entity-select-options?category'} onChange={option => { this.setState({ labelEntities: option }); }} isMulti />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <div>
                                        <label>Start Date</label>
                                    </div>
                                    <DatePicker selected={this.state.startDate} maxDate={this.state.endDate} onChange={(date) => this.setState({ startDate: date })} className="form-control" autoComplete="off" />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <div>
                                        <label>End Date</label>
                                    </div>
                                    <DatePicker name="resolutionDate" selected={this.state.endDate} onChange={(date) => this.setState({ endDate: date })} minDate={this.state.startDate} className="form-control" autoComplete="off" />
                                </div>
                            </div>
                            <div className="col"></div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label>Include all researchers under contacts <br /> <Checkbox checked={this.state.includeAllResearchersUnderContact} onChange={option => { this.setState({ includeAllResearchersUnderContact: option.target.checked }); }} /></label>
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <label>Use unique researchers instead of total researchers <br /> <Checkbox checked={this.state.useUniqueResearchers} onChange={option => { this.setState({ useUniqueResearchers: option.target.checked }); }} /></label>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <button type="submit" className="btn btn-success btn-lg">Filter <FontAwesomeIcon icon="filter" /></button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    renderSummaryTable() {
        return (
            <div className="card my-3">
                <div className="card-header">General</div>
                <div className="card-body">
                    <table className="table table-striped summary-table">
                        <tbody>
                            <tr>
                                <th>Total Contacts</th>
                                <td>{this.state.results.numUniqueContacts}</td>
                            </tr>
                            <tr>
                                <th>Total Researchers</th>
                                <td>{this.state.results.numResearchers}</td>
                            </tr>
                            <tr>
                                <th>Total Unique Researchers</th>
                                <td>{this.state.results.numUniqueResearchers}</td>
                            </tr>
                            <tr>
                                <th>Total Departments</th>
                                <td>{this.state.results.numDepartments}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <h1>Statistics</h1>
                <hr />
                {this.renderFilterForm()}
                {this.state.results != null &&
                    <div>
                        {this.renderSummaryTable()}
                        <div className="card my-3">
                            <div className="card-header">By College</div>
                            <div className="card-body">
                                <div className="chart-container-center">
                                    <Chart
                                        width={800}
                                        height={400}
                                        chartType="Bar"
                                        loader={<div>Loading Chart</div>}
                                        data={this.state.results.contactsByDepartmentArr}
                                        options={{
                                            title: 'Contacts by College'
                                        }}
                                    />
                                </div>
                                <table className="table table-striped summary-table my-3">
                                    <tbody>
                                        {this.state.results.contactsByDepartmentArr.slice(1).map(function (item, index) {
                                            return (<tr key={index}>
                                                <th>{item[0]}</th>
                                                <td>{item[1]}</td>
                                            </tr>);
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card my-3">
                            <div className="card-header">By Department</div>
                            <div className="card-body">
                                <div className="chart-container-center">
                                    <Chart
                                        width={800}
                                        height={400}
                                        chartType="Bar"
                                        loader={<div>Loading Chart</div>}
                                        data={this.state.results.contactsBySubDepartmentArr}
                                        options={{
                                            title: 'Contacts by Department'
                                        }}
                                    />
                                </div>
                                <table className="table table-striped summary-table my-3">
                                    <tbody>
                                        {this.state.results.contactsBySubDepartmentArr.slice(1).map(function (item, index) {
                                            return (<tr key={index}>
                                                <th>{item[0]}</th>
                                                <td>{item[1]}</td>
                                            </tr>);
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card my-3">
                            <div className="card-header">By Contact Type</div>
                            <div className="card-body">
                                <div className="chart-container-center">
                                    <Chart
                                        width={800}
                                        height={400}
                                        chartType="PieChart"
                                        loader={<div>Loading Chart</div>}
                                        data={this.state.results.contactsByTypeArr}
                                        options={{
                                            title: 'Contacts by Contact Type'
                                        }}
                                    />
                                </div>
                                <table className="table table-striped summary-table">
                                    <tbody>
                                        {this.state.results.contactsByTypeArr.slice(1).map(function (item, index) {
                                            return (<tr key={index}>
                                                <th>{item[0]}</th>
                                                <td>{item[1]}</td>
                                            </tr>);
                                        })}
                                    </tbody>
                                </table>
                                {this.state.activityType && this.state.activityType.value == '4' &&
                                    // Render consultation types pie chart
                                    <div>
                                        <div className="chart-container-center">
                                            <Chart
                                                width={800}
                                                height={400}
                                                chartType="PieChart"
                                                loader={<div>Loading Chart</div>}
                                                data={this.state.results.contactsByConsultationTypeArr}
                                                options={{
                                                    title: 'Contacts by Consultation Type'
                                                }}
                                            />
                                        </div>
                                        <table className="table table-striped summary-table">
                                            <tbody>
                                                {this.state.results.contactsByConsultationTypeArr.slice(1).map(
                                                    function (item, index) {
                                                        return (<tr key={index}>
                                                            <th>{item[0]}</th>
                                                            <td>{item[1]}</td>
                                                        </tr>);
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                                {this.state.activityType && this.state.activityType.value == '4' && this.state.consultationType &&
                                    // Render consultation types pie chart
                                    <div>
                                        <div className="chart-container-center">
                                            <Chart
                                                width={800}
                                                height={400}
                                                chartType="PieChart"
                                                loader={<div>Loading Chart</div>}
                                                data={this.state.results.contactsBySubConsultationTypeArr}
                                                options={{
                                                    title: 'Occurrences by Sub Consultation Type'
                                                }}
                                            />
                                        </div>
                                        <table className="table table-striped summary-table">
                                            <tbody>
                                                {this.state.results.contactsBySubConsultationTypeArr.slice(1).map(
                                                    function (item, index) {
                                                        return (<tr key={index}>
                                                            <th>{item[0]}</th>
                                                            <td>{item[1]}</td>
                                                        </tr>);
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </div>
                        </div>
                        {this.state.results.contactsByPositionArr && this.state.results.contactsByPositionArr.length > 1 &&
                            <div className="card my-3">
                                <div className="card-header">By Researcher Position</div>
                                <div className="card-body">
                                    <div className="chart-container-center my-3">
                                        <Chart
                                            width={800}
                                            height={400}
                                            chartType="Bar"
                                            loader={<div>Loading Chart</div>}
                                            data={this.state.results.contactsByPositionArr}
                                            options={{
                                                title: 'Contacts by Researcher Position'
                                            }}
                                        />
                                    </div>
                                    <table className="table table-striped summary-table">
                                        <tbody>
                                            {this.state.results.contactsByPositionArr.slice(1).map(function (item, index) {
                                                return (<tr key={index}>
                                                    <th>{item[0]}</th>
                                                    <td>{item[1]}</td>
                                                </tr>);
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                        {this.state.results.contactsByInterestArr && this.state.results.contactsByInterestArr.length > 1 &&
                            <div className="card my-3">
                                <div className="card-header">By Researcher Area of Interest</div>
                                <div className="card-body">
                                    <div className="chart-container-center my-3">
                                        <Chart
                                            width={800}
                                            height={400}
                                            chartType="Bar"
                                            loader={<div>Loading Chart</div>}
                                            data={this.state.results.contactsByInterestArr}
                                            options={{
                                                title: 'Contacts by Researcher Area of Interest'
                                            }}
                                        />
                                    </div>
                                    <table className="table table-striped summary-table">
                                        <tbody>
                                            {this.state.results.contactsByInterestArr.slice(1).map(function (item, index) {
                                                return (<tr key={index}>
                                                    <th>{item[0]}</th>
                                                    <td>{item[1]}</td>
                                                </tr>);
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }

    async getContacts() {
        // Organize the parameters for the API call
        // Since many of the input fields correspond to a label entity, we bundle them all together
        var paramVars = {};

        if (this.state.startDate) {
            paramVars.startDate = new Date(this.state.startDate).toISOString();
        }

        if (this.state.endDate) {
            paramVars.endDate = new Date(this.state.endDate).toISOString();
        }

        if (this.state.includeAllResearchersUnderContact) {
            paramVars.includeAllResearchersUnderContact = this.state.includeAllResearchersUnderContact;
        }

        if (this.state.useUniqueResearchers) {
            paramVars.useUniqueResearchers = this.state.useUniqueResearchers;
        }

        const params = new URLSearchParams(paramVars);

        paramVars.labelEntityIds = [];

        if (this.state.institutions) {
            this.state.institutions.map(m => params.append('institutionIds', m.value));
        }

        if (this.state.subInstitutions) {
            this.state.subInstitutions.map(m => params.append('subInstitutionIds', m.value));
        }

        if (this.state.activityType) {
            params.append('activityIds', this.state.activityType.value);
        }

        if (this.state.positions) {
            this.state.positions.map(m => params.append('positionIds', m.value));
        }

        if (this.state.interests) {
            this.state.interests.map(m => params.append('interestIds', m.value));
        }

        if (this.state.consultationType) {
            params.append('consultationTypeIds', this.state.consultationType.value);
        }

        //console.log(this.state);

        //if (this.state.labelEntities) {
        //    params.append('labelEntityIds', this.state.labelEntities.value);
        //}

        if (this.state.activityType && this.state.activityType.id == '4') {
            if (this.state.consultationType && (this.state.consultationType.id == "8" || this.state.consultationType.id == "10" || this.state.consultationType.id == "12" || this.state.consultationType.id == "14" || this.state.consultationType.id == "15" || this.state.consultationType.id == "206")) {
                if (this.state.labelEntities) {
                    this.state.labelEntities.map(m => params.append('labelEntityIds', m.value));
                }
            }
        }

        console.log(params);
        console.log(paramVars);

        const response = await fetch('api/statistics/get-contacts?' + params);
        const data = await response.json();

        // Prepend axis labels to data
        data.contactsByDepartmentArr.unshift(["College", "Num Researchers"]);
        data.contactsBySubDepartmentArr.unshift(["Department", "Num Researchers"]);
        data.contactsByTypeArr.unshift(["Contact Type", "Num Contacts"]);
        data.contactsByConsultationTypeArr.unshift(["Consultation Type", "Num Contacts"]);
        data.contactsBySubConsultationTypeArr.unshift(["Sub Consultation Type", "Num Researchers"]);
        data.contactsByPositionArr.unshift(["Researcher Position", "Num Researchers"]);
        data.contactsByInterestArr.unshift(["Researcher Area of Interest", "Occurrences"]);

        console.log(data);

        this.setState({ results: data });
    }
}